<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
  original: { type: Object, required: true },
  candidate: { type: Object, required: true },
  portals: { type: Array, default: () => [] },
});
const { t } = useI18n();
const changedFields = computed(() =>
  Object.keys(props.candidate).filter(
    key =>
      JSON.stringify(props.candidate[key]) !==
      JSON.stringify(props.original[key])
  )
);
const display = (key, value) => {
  if (key === 'portal_id')
    return props.portals.find(p => p.id === value)?.name || t('AI_CONFIG.NONE');
  if (typeof value === 'boolean')
    return t(value ? 'AI_CONFIG.ON' : 'AI_CONFIG.OFF');
  if (Array.isArray(value)) return value.join('、') || t('AI_CONFIG.NONE');
  if (['reply_language', 'reply_style'].includes(key))
    return t(`AI_CONFIG.VALUES.${value}`);
  return value || t('AI_CONFIG.NONE');
};
</script>

<template>
  <div class="grid gap-3">
    <p v-if="!changedFields.length" class="text-sm text-n-slate-11">
      {{ t('AI_CONFIG.NO_CHANGES') }}
    </p>
    <section
      v-for="key in changedFields"
      :key="key"
      class="rounded-lg border border-n-weak p-3"
    >
      <h4 class="text-sm font-medium text-n-slate-12">
        {{ t(`AI_CONFIG.FIELDS.${key}`) }}
      </h4>
      <div
        class="grid grid-cols-2 gap-3 mt-2 text-sm whitespace-pre-wrap break-words"
      >
        <div>
          <span class="text-xs text-n-slate-11">{{
            t('AI_CONFIG.BEFORE')
          }}</span>
          <p class="mt-1 text-n-slate-11">{{ display(key, original[key]) }}</p>
        </div>
        <div>
          <span class="text-xs text-n-blue-11">{{ t('AI_CONFIG.AFTER') }}</span>
          <p class="mt-1 text-n-slate-12">{{ display(key, candidate[key]) }}</p>
        </div>
      </div>
    </section>
  </div>
</template>
